import { type BookmarksIdeaBoardAttributes } from './generated/BookmarksIdeaBoardAttributes';
import ApplicationModel, { attr } from '../ApplicationModel';
import { model } from '../modelBuilder';
import CardLayout from './CardLayout';
import Fragment from '../Fragment';
import { IdeaBoardGroupBy } from '../Enums';

interface BookmarksIdeaBoard extends BookmarksIdeaBoardAttributes {}

@model
class BookmarksIdeaBoard extends ApplicationModel {
  // Start auto-generated
  static typename: 'BookmarksIdeaBoard' = 'BookmarksIdeaBoard';
  get typename(): 'BookmarksIdeaBoard' {
    return 'BookmarksIdeaBoard';
  }

  static internalTypename: 'Bookmarks::IdeaBoard' = 'Bookmarks::IdeaBoard';
  get internalTypename(): 'Bookmarks::IdeaBoard' {
    return 'Bookmarks::IdeaBoard';
  }

  static bookmarkName = 'Bookmarks::IdeaBoard';

  static inputType = 'IdeaBoardAttributes!';

  static fields = {
    groupBy: attr({ writable: true, readable: true }),
    id: attr({ readable: true }),
    name: attr({ readable: true }),
    positionerId: attr({ readable: true }),
    projectId: attr({ readable: true }),
    selectedAssignedToUserIds: attr({ writable: true, readable: false }),
    selectedBoardProjectIds: attr({ writable: true, readable: false }),
    selectedIdeaCategoryIds: attr({ writable: true, readable: false }),
    selectedIdeaThemeIds: attr({ writable: true, readable: false }),
    showCollapsedView: attr({ writable: true, readable: true }),
    cardLayout: attr.belongsTo({
      writeShape: [
        'epicRecordLayout',
        'featureRecordLayout',
        'ideaRecordLayout',
        'initiativeRecordLayout',
        'releaseRecordLayout',
        'releasePhaseRecordLayout',
        'requirementRecordLayout',
        'taskRecordLayout',
        'goalRecordLayout',
        'keyResultRecordLayout',
      ],
      readable: true,
      typename: 'CardLayout',
    }),
    defaultCardLayout: attr.belongsTo({
      readable: true,
      typename: 'CardLayout',
    }),
    idea: attr.belongsTo({ readable: true, typename: 'Idea' }),
    ideas: attr.belongsTo({
      args: {
        page: 'Int',
        per: 'Int',
        assignedToUserId: 'ID',
        projectId: 'ID',
        ideaThemeId: 'ID',
        ideaCategoryId: 'ID',
        searchQuery: 'String',
      },
      readable: true,
      typename: 'IdeaPage',
    }),
    project: attr.belongsTo({ readable: true, typename: 'Project' }),
    groupSelectOptions: attr.hasMany({ readable: true }),
  };
  // End auto-generated

  get activeCardLayout() {
    const { cardLayout, defaultCardLayout } = this;

    if (cardLayout && defaultCardLayout) {
      return CardLayout.buildActiveCardLayout({
        cardLayout,
        defaultCardLayout,
      });
    }
  }

  get cardView() {
    return this.showCollapsedView
      ? this.activeCardLayout?.ideaRecordLayout?.collapsed
      : this.activeCardLayout?.ideaRecordLayout?.expanded;
  }

  async updateGroupSelection(selectedIds: RecordId[]) {
    let mutationField = '';
    switch (this.groupBy) {
      case IdeaBoardGroupBy.ASSIGNEE.value:
        mutationField = 'selectedAssignedToUserIds';
        break;
      case IdeaBoardGroupBy.PROJECT.value:
        mutationField = 'selectedBoardProjectIds';
        break;
      case IdeaBoardGroupBy.THEME.value:
        mutationField = 'selectedIdeaThemeIds';
        break;
      case IdeaBoardGroupBy.CATEGORY.value:
        mutationField = 'selectedIdeaCategoryIds';
        break;
    }

    if (mutationField) {
      await this.mutate(
        new Fragment('updateBookmarksIdeaBoard')
          .argument('id', this.id)
          .argument(
            'attributes',
            {
              [mutationField]: selectedIds,
            },
            'IdeaBoardAttributes!'
          )
      );
    }
  }
}

export default BookmarksIdeaBoard;
